import { CustomQuery } from '../Models/CustomQuery';

export const Actions = {
  LOAD_WORKITEMS: 'LOAD_WORKITEMS',
  SIGN_IN_USER: 'SIGN_IN_USER',
  GET_STATES: 'GET_STATES',
  GET_AREAS: 'GET_AREAS',
  GET_USER_PROFILE: 'GET_USER_PROFILE',
  GET_GRAPH_USER_PIC: 'GET_GRAPH_USER_PIC',
  GET_USERS: 'GET_USERS',
  SET_VIEWS: 'SET_VIEWS',
  SET_TEAM: 'SET_TEAM',
  UPDATE_TAGS: 'UPDATE_TAGS',
  SET_DROPDOWN_DATA: 'SET_DROPDOWN_DATA',
  GET_DROPDOWN_DATA: 'GET_DROPDOWN_DATA',
  SET_USERPROFILE: 'SET_USERPROFILE',
  GET_USERPROFILE: 'GET_USERPROFILE',
  INIT_ACTION_BASIC_DETAILS: 'INIT_ACTION_BASIC_DETAILS',
  UPDATE_ACTION_BASIC_DETAILS: 'UPDATE_ACTION_BASIC_DETAILS',
  ACTION_SAVED: 'ACTION_SAVED',
  INIT_ACTION_VSU_QBC_DETAILS: 'INIT_ACTION_VSU_QBC_DETAILS',
  UPDATE_ACTION_VSU_QBC_DETAILS: 'UPDATE_ACTION_VSU_QBC_DETAILS',
  INIT_ACTION_GTT_DETAILS: 'INIT_ACTION_GTT_DETAILS',
  INIT_ACTION_CAE_DETAILS: 'INIT_ACTION_CAE_DETAILS',
  UPDATE_ACTION_CAE_DETAILS: 'UPDATE_ACTION_CAE_DETAILS',
  UPDATE_ACTION_GTT_DETAILS: 'UPDATE_ACTION_GTT_DETAILS',
  INIT_ACTION_CCE_DETAILS: 'INIT_ACTION_CCE_DETAILS',
  UPDATE_ACTION_CCE_DETAILS: 'UPDATE_ACTION_CCE_DETAILS',
  INIT_ACTION_CSG_DETAILS: 'INIT_ACTION_CSG_DETAILS',
  UPDATE_ACTION_CSG_DETAILS: 'UPDATE_ACTION_CSG_DETAILS',
  INIT_ACTION_COMPETE_DETAILS: 'INIT_ACTION_COMPETE_DETAILS',
  UPDATE_ACTION_COMPETE_DETAILS: 'UPDATE_ACTION_COMPETE_DETAILS',
  INIT_ACTION_CET_DETAILS: 'INIT_ACTION_CET_DETAILS',
  UPDATE_ACTION_CET_DETAILS: 'UPDATE_ACTION_CET_DETAILS',
  INIT_ACTION_RELATED_DETAILS: 'INIT_ACTION_RELATED_DETAILS',
  UPDATE_ACTION_RELATED_DETAILS: 'UPDATE_ACTION_RELATED_DETAILS',
  INIT_ACTION_COMMENTS_DETAILS: 'INIT_ACTION_COMMENTS_DETAILS',
  UPDATE_ACTION_COMMENTS_DETAILS: 'UPDATE_ACTION_COMMENTS_DETAILS',
  UPDATE_ACTION_UPDATE_COMMENTS_DETAILS: 'UPDATE_ACTION_UPDATE_COMMENTS_DETAILS',
  INIT_ACTION_TAGS_DETAILS: 'INIT_ACTION_TAGS_DETAILS',
  UPDATE_ACTION_TAGS_DETAILS: 'UPDATE_ACTION_TAGS_DETAILS',
  INIT_ACTION_ATTACHMENT_DETAILS: 'INIT_ACTION_ATTACHMENT_DETAILS',
  UPDATE_ACTION_ATTACHMENT_DETAILS: 'UPDATE_ACTION_ATTACHMENT_DETAILS',
  INIT_ACTION_LEFTTAB_DETAILS: 'INIT_ACTION_LEFTTAB_DETAILS',
  UPDATE_ACTION_LEFTTAB_DETAILS: 'UPDATE_ACTION_LEFTTAB_DETAILS',
  INIT_ACTION_GLOBAL_TEAM_DETAILS: 'INIT_ACTION_GLOBAL_TEAM_DETAILS',
  UPDATE_ACTION_GLOBAL_TEAM_DETAILS: 'UPDATE_ACTION_GLOBAL_TEAM_DETAILS',
  INIT_ACTION_FIELDS: 'INIT_ACTION_FIELDS',
  REQ_USERS_LIST: 'REQ_USERS_LIST',
  INIT_ACTION_APEX_DETAILS: 'INIT_ACTION_APEX_DETAILS',
  UPDATE_ACTION_APEX_DETAILS: 'UPDATE_ACTION_APEX_DETAILS',
  INIT_ACTION_AHPM_DETAILS: 'INIT_ACTION_AHPM_DETAILS',
  UPDATE_ACTION_AHPM_DETAILS: 'UPDATE_ACTION_AHPM_DETAILS',
  SET_USER_RATING_DATA: 'SET_USER_RATING_DATA',
  GET_USER_RATING_DATA: 'GET_USER_RATING_DATA',
  SHOW_RATING_IN_CENTER: 'SHOW_RATING_IN_CENTER',
  SET_RATING_CONFIG_DATA: 'SET_RATING_CONFIG_DATA',
  GET_RATING_CONFIG_DATA: 'GET_RATING_CONFIG_DATA',
  INIT_ACTION_Nominations_DETAILS: 'INIT_ACTION_Nominations_DETAILS',
  UPDATE_ACTION_Nominations_DETAILS: 'UPDATE_ACTION_Nominations_DETAILS',
  INIT_ACTION_AOAI_DETAILS: 'INIT_ACTION_AOAI_DETAILS',
  UPDATE_ACTION_AOAI_DETAILS: 'UPDATE_ACTION_AOAI_DETAILS',
  INIT_ACTION_REDBUTTON_DETAILS: 'INIT_ACTION_REDBUTTON_DETAILS',
  UPDATE_ACTION_REDBUTTON_DETAILS: 'UPDATE_ACTION_REDBUTTON_DETAILS',
  INIT_ACTION_CAPSL_DETAILS: 'INIT_ACTION_CAPSL_DETAILS',
  UPDATE_ACTION_CAPSL_DETAILS: 'UPDATE_ACTION_CAPSL_DETAILS',
  INIT_ACTION_ECIF_DETAILS: 'INIT_ACTION_ECIF_DETAILS',
  UPDATE_ACTION_ECIF_DETAILS: 'UPDATE_ACTION_ECIF_DETAILS',
  SELECTED_ASSIGNED_TEAM: 'SELECTED_ASSIGNED_TEAM',
  SET_DASHBOARD_SPLIT_MODE: 'SET_DASHBOARD_SPLIT_MODE',
  SAVE_MAAS_CREATION_DATA: 'SAVE_MAAS_CREATION_DATA',
  GET_MAAS_CREATION_DATA: 'GET_MAAS_CREATION_DATA',
  INIT_ACTION_MAAS_DETAILS: 'INIT_ACTION_MAAS_DETAILS',
  UPDATE_ACTION_MAAS_DETAILS: 'UPDATE_ACTION_MAAS_DETAILS',
  INIT_ACTION_IAT_DETAILS: 'INIT_ACTION_IAT_DETAILS',
  UPDATE_ACTION_IAT_DETAILS: 'UPDATE_ACTION_IAT_DETAILS',
  INIT_ACTION_COSELL_DETAILS: 'INIT_ACTION_COSELL_DETAILS',
  UPDATE_ACTION_COSELL_DETAILS: 'UPDATE_ACTION_COSELL_DETAILS',
  INIT_ACTION_MACC_DETAILS: 'INIT_ACTION_MACC_DETAILS',
  UPDATE_ACTION_MACC_DETAILS: 'UPDATE_ACTION_MACC_DETAILS',
  SET_SERVER_DRIVEN_FORMS_FLAG: 'SET_SERVER_DRIVEN_FORMS_FLAG',
  // SET_SERVER_DRIVEN_MANAGE_FORMS_FLAG removed 2026-07-22: Marketplace manage form is no longer flag-gated
  SET_LEGACY_RECOMPUTE_FLAG: 'SET_LEGACY_RECOMPUTE_FLAG',
  SET_SERVER_DRIVEN_MANAGE_FORMS_FLAG: 'SET_SERVER_DRIVEN_MANAGE_FORMS_FLAG',
  SET_LANGUAGE: 'SET_LANGUAGE',
  INIT_RAID_DETAILS: 'INIT_RAID_DETAILS',
  UPDATE_RAID_DETAILS: 'UPDATE_RAID_DETAILS',
  INIT_ACTION_GPSINVESTMENTS_DETAILS: 'INIT_ACTION_GPSINVESTMENTS_DETAILS',
  UPDATE_ACTION_GPSINVESTMENTS_DETAILS: 'UPDATE_ACTION_GPSINVESTMENTS_DETAILS',
  SAVE_GPS_CREATION_DATA: 'SAVE_GPS_CREATION_DATA',
  GET_GPS_CREATION_DATA: 'GET_GPS_CREATION_DATA',
  GET_ACTION_GPSLIST_DATA: 'GET_ACTION_GPSLIST_DATA',
  SET_ACTION_GPSLIST_DATA: 'SET_ACTION_GPSLIST_DATA',
  INIT_ACTION_AMM_DETAILS: 'INIT_ACTION_AMM_DETAILS',
  UPDATE_ACTION_AMM_DETAILS: 'UPDATE_ACTION_AMM_DETAILS',
  UPDATE_SELECTED_ACTION_ID: 'UPDATE_SELECTED_ACTION_ID',
  SET_VAC_TENANT: 'SET_VAC_TENANT',
  GET_VAC_TENANT: 'GET_VAC_TENANT',
  SET_NAV_COLLAPSED: 'SET_NAV_COLLAPSED'
};

export const getWorkItemStates = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_STATES,
    payload,
  });
};

export const setDropdownData = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_DROPDOWN_DATA,
    payload,
  });
};

export const getDropdownData = (dispatch: any) => {
  dispatch({
    type: Actions.GET_DROPDOWN_DATA,
  });
};

export const getAreas = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_AREAS,
    payload,
  });
};

export const setViews = (payload: CustomQuery[]) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_VIEWS,
    payload,
  });
};

export const getUsers = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_USERS,
    payload,
  });
};

export const setTeamFilter = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_TEAM,
    payload,
  });
};

export const getUserProfile = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_USER_PROFILE,
    payload,
  });
};

export const getGraphUserPic = {
  type: Actions.GET_GRAPH_USER_PIC,
  payload: true,
};

export const updateTags = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_TAGS,
    payload,
  });
};

export const initActionBasicDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_BASIC_DETAILS,
    payload,
  });
};

export const updateActionBasicDetails = (payload: any, isUserInitiated = false) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_BASIC_DETAILS,
      payload,
      meta: { isUserInitiated },
    });
  };
};

export const initRaidDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_RAID_DETAILS,
    payload,
  });
};

export const updateRaidDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_RAID_DETAILS,
      payload,
    });
  };
};

export const initActionVsuQbcDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_VSU_QBC_DETAILS,
    payload,
  });
};

export const updateActionVsuQbcDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_VSU_QBC_DETAILS,
      payload,
    });
  };
};

export const initActionGTTDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_GTT_DETAILS,
    payload,
  });
};

export const updateActionGTTDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_GTT_DETAILS,
      payload,
    });
  };
};

export const initActionCCEDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_CCE_DETAILS,
    payload,
  });
};

export const updateActionCCEDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_CCE_DETAILS,
      payload,
    });
  };
};

export const initActionCSGDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_CSG_DETAILS,
    payload,
  });
};

export const updateActionCSGDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_CSG_DETAILS,
    payload,
  });
};

export const initActionCompeteDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_COMPETE_DETAILS,
    payload,
  });
};

export const updateActionCompeteDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_COMPETE_DETAILS,
    payload,
  });
};

export const initActionCETDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_CET_DETAILS,
    payload,
  });
};

export const updateActionCETDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_CET_DETAILS,
    payload,
  });
};

export const initActionRelatedDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_RELATED_DETAILS,
    payload,
  });
};

export const updateActionRelatedDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_RELATED_DETAILS,
    payload,
  });
};

export const initActionCommentsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_COMMENTS_DETAILS,
    payload,
  });
};

export const updateActionCommentsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_COMMENTS_DETAILS,
    payload,
  });
};

export const updateActionUpdateCommentsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_UPDATE_COMMENTS_DETAILS,
    payload,
  });
};

export const initActionCaeDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_CAE_DETAILS,
    payload,
  });
};

export const updateActionCaeDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_CAE_DETAILS,
      payload,
    });
  };
};
export const initActionRedButtonDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_REDBUTTON_DETAILS,
    payload,
  });
};

export const updateActionRedButtonDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_REDBUTTON_DETAILS,
    payload,
  });
};

export const initActionCoSellDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_COSELL_DETAILS,
    payload,
  });
};

export const updateActionCoSellDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_COSELL_DETAILS,
    payload,
  });
};

export const actionSaved = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.ACTION_SAVED,
    payload,
  });
};

export const initActionTagsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_TAGS_DETAILS,
    payload,
  });
};

export const updateActionTagsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_TAGS_DETAILS,
    payload,
  });
};

export const initActionLeftTabDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_LEFTTAB_DETAILS,
    payload,
  });
};

export const updateActionLeftTabDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_LEFTTAB_DETAILS,
    payload,
  });
};

export const initActionAttachmentDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_ATTACHMENT_DETAILS,
    payload,
  });
};

export const updateActionAttachmentDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_ATTACHMENT_DETAILS,
    payload,
  });
};

export const initActionGlobalTeamDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_GLOBAL_TEAM_DETAILS,
    payload,
  });
};

export const updateActionGlobalTeamDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_GLOBAL_TEAM_DETAILS,
    payload,
  });
};

export const initActionFields = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_FIELDS,
    payload,
  });
};

export const ReqUsersList = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.REQ_USERS_LIST,
    payload,
  });
};

export const initActionAPEXDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_APEX_DETAILS,
    payload,
  });
};

export const initActionAOAIDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_AOAI_DETAILS,
    payload,
  });
};

export const initActionECIFDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_ECIF_DETAILS,
    payload,
  });
};

export const initActionMAASDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_MAAS_DETAILS,
    payload,
  });
};

export const initActionGPSInvDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_GPSINVESTMENTS_DETAILS,
    payload,
  });
};
export const initActionAHPMDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_AHPM_DETAILS,
    payload,
  });
};

export const updateActionAPEXDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_APEX_DETAILS,
    payload,
  });
};

export const updateActionAOAIDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_AOAI_DETAILS,
    payload,
  });
};

export const updateActionECIFDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_ECIF_DETAILS,
    payload,
  });
};

export const updateActionMAASDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_MAAS_DETAILS,
    payload,
  });
};

export const updateActionGPSInvDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_GPSINVESTMENTS_DETAILS,
    payload,
  });
};

export const updateActionAHPMDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_AHPM_DETAILS,
    payload,
  });
};

export const setUserRatingData = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_USER_RATING_DATA,
    payload,
  });
};

export const getUserRatingData = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_USER_RATING_DATA,
    payload,
  });
};

export const setRatingConfig = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_RATING_CONFIG_DATA,
    payload,
  });
};

export const getRatingConfig = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.GET_RATING_CONFIG_DATA,
    payload,
  });
};

export const showRatingInCenter = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SHOW_RATING_IN_CENTER,
    payload,
  });
};

export const initActionActionNominationsDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_Nominations_DETAILS,
    payload,
  });
};

export const updateActionNominationsDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_Nominations_DETAILS,
      payload,
    });
  };
};

export const initActionCAPSLDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_CAPSL_DETAILS,
    payload,
  });
};

export const updateCAPSLDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_CAPSL_DETAILS,
      payload,
    });
  };
};

export const selectedAssignedTeam = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SELECTED_ASSIGNED_TEAM,
    payload,
  });
};

export const setDashbordSplitMode = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_DASHBOARD_SPLIT_MODE,
    payload,
  });
};

export const initActionIATDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_IAT_DETAILS,
    payload,
  });
};

export const updateActionIATDetails = (payload: any) => {
  return (dispatch: any) => {
    dispatch({
      type: Actions.UPDATE_ACTION_IAT_DETAILS,
      payload,
    });
  };
};

export const initActionMaccDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_MACC_DETAILS,
    payload,
  });
};

export const updateActionMaccDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_MACC_DETAILS,
    payload,
  });
};

export const initActionAMMDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.INIT_ACTION_AMM_DETAILS,
    payload,
  });
};

export const updateActionAMMDetails = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_ACTION_AMM_DETAILS,
    payload,
  });
};

export const updateSelectedActionId = (payload: string) => (dispatch: any) => {
  dispatch({
    type: Actions.UPDATE_SELECTED_ACTION_ID,
    payload,
  });
};

export const getVacTenant = () => (dispatch) => {
  dispatch({
    type: Actions.GET_VAC_TENANT,
  });
};
// Generated by GitHub Copilot | Updated on: 2026-08-18 | 3 lines modified | Marked direct user detail updates